@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.modal-body {
  display: flex;
  padding: @space-16;
  flex-direction: column;
  align-items: flex-start;
  gap: @space-16;
}

.blocked-message {
  text-align: center;
  width: 100%;
}
